// @avantia common-code
import * as dateFns from 'date-fns';
import { Addon, AddonDetails, Endorsement, Excesses, Policy, SpecifiedItem } from '../types/policyTypes';

export const loremIpsum = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et doloreea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et doloreea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.`;

const applyShortDateFormat = (date: Date): string =>
  date.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });

// Dates are kept dynamic so the Selenium tests always have a valid policy to test against.
// Start date is 6 months ago and end date is 6 months from now so today always sits mid-term.
export const mockPolicyStartDate = applyShortDateFormat(dateFns.subMonths(new Date(), 6));
export const mockPolicyEndDate = applyShortDateFormat(dateFns.addMonths(new Date(), 6));

export const mockSpecifiedItems: SpecifiedItem[] = [
  { description: 'IPad Air 64Gb', amount: 579, category: 'Laptops', isAwayFromHomeCover: true },
  { description: 'Dell Latitude E5420', amount: 2300, category: 'Laptops', isAwayFromHomeCover: false }
];

export const endorsements: Endorsement[] = [
  { name: 'AR000104 - CCI. Minimum Contents Cover', description: loremIpsum, code: 'sdasdsa', order: 1 },
  { name: 'THEFTCOV - Theft Explanation', description: loremIpsum, code: 'sdasdsa', order: 2 },
  { name: 'OUTBDCOV - Possessions stored in Outbuildings', description: loremIpsum, code: 'sdasdsa', order: 3 },
  { name: 'FloodRe', description: loremIpsum, code: 'sdasdsa', order: 4 }
];

const homeEmergencyAddon: Addon = {
  name: 'DAS Basic Home Emergency hp2',
  description:
    'Please call to claim. If this is an ongoing incident or your home is not safe or habitable, call our Home Emergency team on 0330 660 0660.',
  code: 'sdasdsa',
  order: 1,
  claimsNumber: '123212121312',
  hasHomeEmergency: true,
  hasKeyProtect: true,
  hasLegalExpenses: false,
  hasRentGuarantee: false
};

const legalExpensesAddon: Addon = {
  name: 'DAS Basic Legal Expenses hp2',
  description: 'Please call to claim. For Legal Expenses claims please call us 0330 660 0660.',
  code: 'sdasdsa',
  order: 2,
  claimsNumber: '123212121312',
  hasHomeEmergency: true,
  hasKeyProtect: true,
  hasLegalExpenses: false,
  hasRentGuarantee: false
};

export const mockAddons: Addon[] = [homeEmergencyAddon, legalExpensesAddon];

export const mockAddonDetails: AddonDetails = {
  addons: mockAddons,
  availableAddons: { HomeEmergency: homeEmergencyAddon, LegalExpenses: legalExpensesAddon }
};

export const mockAvailableAddons = mockAddonDetails.availableAddons;

export const noAddonDetails: AddonDetails = { addons: [], availableAddons: {} };

export const mockExcesses: Excesses = {
  compulsoryExcesses: [
    { description: 'Subsidence, Landslip and Heave Excess Applies', amount: 1000, order: 1 },
    { description: 'Escape of Water Excess Applies', amount: 250, order: 2 },
    {
      description: 'Section 2 Standard Excess applicable to Contents including specified items within the home',
      amount: 100,
      order: 3
    }
  ],
  voluntaryExcesses: [
    { description: 'Section 1 Buildings Voluntary Excess', amount: 1000, order: 1 },
    { description: 'Section 1 Buildings Voluntary Excess', amount: 500, order: 2 }
  ]
};

/**
 * Returns a fully-populated Policy with sensible defaults. Pass only the properties that make
 * this policy distinctive — everything else is filled in from the base.
 */
export function createMockPolicy(
  overrides: Partial<Policy> & Pick<Policy, 'policyNumber' | 'policyDetailsId' | 'coverType'>
): Policy {
  return {
    title: 'Mr',
    forename: 'Steve',
    surname: 'Nhitest',
    dateOfBirth: new Date('1964-04-16T00:00:00'),
    phoneNumber: '0000000001',
    altPhoneNumber: '0000000001',
    historyId: 1,
    house: 'The Mock House',
    street: 'Mock Street',
    locality: '',
    county: '',
    postcode: 'SY22 5HU',
    inceptionDate: mockPolicyStartDate,
    startDate: mockPolicyStartDate,
    endDate: mockPolicyEndDate,
    productDescription: 'Evan',
    buildingsSumInsured: 250000,
    contentsSumInsured: 50000,
    outbuildingsSumInsured: 0,
    personalPossessionsSumInsured: 0,
    accidentalDamageLevel: { Buildings: 'None', Contents: 'None' },
    endorsements,
    addonDetails: mockAddonDetails,
    excesses: mockExcesses,
    exBuildingAD: false,
    exContentsAD: false,
    exFlood: false,
    exSubs: false,
    isFleea: false,
    isFloodRe: false,
    isUnoccupied: false,
    hasUnoccupiedExtendedPerils: false,
    specifiedItems: [],
    additionalPolicyHolders: [],
    claims: [],
    ...overrides
  };
}
